import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'
import { setBrowserCookie } from '@backmarket/utils/cookies/setBrowserCookie'

import { COOKIE_LANGUAGE } from '../constants'

import { replaceLocaleInPath } from './replaceLocaleInPath'

type ChangeLanguageOptions = {
  shouldUpdatePath?: boolean
  next?: string
}

export function changeLanguage(
  locale: Bcp47Locale,
  options?: ChangeLanguageOptions,
) {
  const { shouldUpdatePath = false, next } = options ?? {}

  setBrowserCookie(COOKIE_LANGUAGE, locale, { path: '/' })

  if (shouldUpdatePath) {
    const url = new URL(window.location.href)
    url.pathname = replaceLocaleInPath(url.pathname, locale)
    window.location.href = url.toString()
  } else if (next) {
    window.location.href = next
  } else {
    window.location.reload()
  }
}
